import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class WarehouseReleaseProductRequest {
  @jsonMember(String)
  public readonly goodId: Guid;

  @jsonMember(Number)
  public readonly quantity: number;

  public constructor(data: { id: Guid; quantity: number }) {
    this.goodId = data.id;
    this.quantity = data.quantity;
  }
}
